<template>
    <div class="bidding_amount flex flex_center">
		<div class="close_box margin_r">
			<span class="close_icon" @click="clear">x</span>
		</div>
        <el-tooltip placement="bottom" :open-delay="500" :disabled="!tooltip">
            <span slot="content" v-html="tooltip"></span>
            <span class="flex_1">{{$t("investor.exchange.table.operation.bid")}}</span>
        </el-tooltip>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    computed: {
        ...mapGetters(["exchangeCheckedRows"]),
        tooltip() {
            return this.$t("investor.exchange.table.operation.bid.tooltip");
        },
    },
    methods: {
        clear() {
            this.params.api.forEachNode(rowNode => {
                rowNode.data.bidInput = "";
            });
        }
    }
};
</script>

<style lang="scss" scoped>
@import "src/components/templates/investor/exchange/bidInput.scss";
</style>
